module.exports = __webpack_public_path__ + "img/print.9b5db3c.jpg";